import React, { Component } from "react";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import { apiUrl } from "../Helpers/Config";
import { showLoader, hideLoader } from "../Helpers/SettingHelper";
import "react-spring-bottom-sheet/dist/style.css";
import "./MyAccountBookings.scss";
import ModalPopup from "../../common/components/ModalPopup/ModalPopup";
import AlertPopup from "../../common/components/AlertPopup/AlertPopup";
import BookingAndCancellationCard from "./BookingAndCancellationCard";

let qs = require("qs");

class Listpromo extends Component {
  constructor(props) {
    super(props);

    let UserId = "";
    if (cookie.load("UserId")) {
      UserId = cookie.load("UserId");
    }

    let prevPage = "";
    if (
      this.props.location?.state !== undefined &&
      this.props.location?.state.prevPage !== undefined
    ) {
      prevPage = this.props.location.state.prevPage;
    }

    let activeTab;
    if (this.props.activeTab) {
      activeTab = this.props.activeTab;
    }
    this.state = {
      userId: UserId,
      booking_id: "",
      ticket_id: "",
      ticket_code: "",
      cancelPopupList: [],
      cancelList: [],
      cancelerrorMsg: false,
      cancelled_list: [],
      cancel_reason: "",
      cancel_other_reason: "",
      error_cancel_reason: "",
      error_cancel_other_reason: "",
      showLoadMore: false,
      isMobile: window.innerWidth <= 480,
      loading: false,
      prevPage: prevPage,
      openAlertPopup: false,
      popupTitle: "",
      alertPopupMsg: "",
      openTicketPopup: false,
      activeTab: activeTab,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  cancellTicket(booking) {
    this.setState({
      cancelPopupList: booking,
      booking_id: booking.booking_id,
      openTicketPopup: true,
    });
  }

  handleChange = (event) => {
    let cancelList = this.state.cancelList;

    if (event.target.checked === true) {
      cancelList.push(event.target.value);
    } else {
      const index = cancelList.indexOf(event.target.value);
      cancelList.splice(index, 1);
    }

    this.setState({ cancelList: cancelList, cancelerrorMsg: false });
  };

  confirmCancel() {
    let error = 0;

    if (this.state.cancelList.length === 0) {
      this.setState({ cancelerrorMsg: true });
      error++;
    } else {
      this.setState({ cancelerrorMsg: false });
    }
    if (this.state.cancel_reason === "") {
      error++;
      this.setState({ error_cancel_reason: "Please select any one reason" });
    } else {
      this.setState({ error_cancel_reason: "" });
    }
    if (this.state.cancel_reason === "Others") {
      if (this.state.cancel_other_reason === "") {
        error++;
        this.setState({
          error_cancel_other_reason: "Please enter other reason",
        });
      } else {
        this.setState({ error_cancel_other_reason: "" });
      }
    } else {
      this.setState({ error_cancel_other_reason: "" });
    }
    if (error === 0) {
      this.setState({ loading: true });
      let postObject = {
        customer_id: this.state.userId,
        booking_id: this.state.booking_id,
        itinerary: this.state.cancelList.join(","),
        cancel_reason: this.state.cancel_reason,
        cancel_other_reason: this.state.cancel_other_reason,
      };
      showLoader("proceed_cancel", "class");
      axios
        .post(apiUrl + "booking/cancelRequest", qs.stringify(postObject), {
          headers: {
            Authorization: cookie.load("acccesstoken"),
          },
        })
        .then((res) => {
          hideLoader("proceed_cancel", "class");
          if (res.data.status === "ok") {
            this.setState({
              openAlertPopup: true,
              popupTitle: "Success",
              alertPopupMsg: res.data.message,
            });
          } else if (res.data.status === "error") {
            this.setState({
              openAlertPopup: true,
              popupTitle: "Error",
              alertPopupMsg: res.data.message,
            });
          }
          this.setState({ loading: false, openTicketPopup: false });
        });
    }
  }

  handleCloseCancellationPopup = () => {
    this.setState({
      openTicketPopup: false,
      cancelerrorMsg: false,
      error_cancel_reason: "",
    });
  };

  handleSelectChange(field, event) {
    this.setState({
      [field]: event.value,
      ["error_" + field]: "",
      error_cancel_other_reason: "",
    });
  }

  handleTextChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      ["error_" + event.target.name]: "",
    });
  }

  sateValChange = (field, value) => {
    if (field === "isFlight") {
      this.props.history.push({
        pathname: "/",
        state: {
          isFlight: value,
          isActivities: false,
          isVacation: false,
        },
      });
    }
    if (field === "isActivities") {
      this.props.history.push({
        pathname: "/",
        state: {
          isFlight: false,
          isActivities: value,
          isVacation: false,
        },
      });
    }
    if (field === "isVacation") {
      this.props.history.push({
        pathname: "/",
        state: {
          isFlight: false,
          isActivities: false,
          isVacation: value,
        },
      });
    }
    this.setState({ [field]: value });
  };

  render() {
    return (
      <>
        <BookingAndCancellationCard
          pageFor="bookings"
          state={this.state}
          setState={this.setState}
          cancellTicket={this.cancellTicket.bind(this)}
          activeTab={this.state.activeTab}
          buttonLoader={this.props.buttonLoader}
        />
        <AlertPopup
          open={this.state.openAlertPopup}
          handleClose={() => this.setState({ openAlertPopup: false })}
          title={this.state.popupTitle}
          message={this.state.alertPopupMsg}
        />
        <ModalPopup
          open={this.state.openTicketPopup}
          handleClose={() => this.handleCloseCancellationPopup()}
        >
          <div className="cancel-itinerary-popup">
            <div className="cip-header">
              <h3>
                Choose your <span>Itinerary</span>
              </h3>
            </div>
            <div className="cip-checkbox-cntnr">
              {Object.keys(this.state.cancelPopupList).length && (
                <ul>
                  {this.state.cancelPopupList.flight === "Yes" && (
                    <li>
                      <input
                        name="flight"
                        type="checkbox"
                        onChange={this.handleChange}
                        value="Flight"
                      />
                      <label for="flight">Flight</label>
                    </li>
                  )}
                  {this.state.cancelPopupList.hotel === "Yes" && (
                    <li>
                      <input
                        name="hotel"
                        type="checkbox"
                        onChange={this.handleChange}
                        value="Hotel"
                      />
                      <label for="hotel">Hotel</label>
                    </li>
                  )}
                  {this.state.cancelPopupList.transfer === "Yes" && (
                    <li>
                      <input
                        name="transfer"
                        type="checkbox"
                        onChange={this.handleChange}
                        value="Transfer"
                      />
                      <label for="transfer">Transfer</label>
                    </li>
                  )}
                  {this.state.cancelPopupList.totalActivity > 0 && (
                    <li>
                      <input
                        name="ttd"
                        type="checkbox"
                        onChange={this.handleChange}
                        value="things to do"
                      />
                      <label for="ttd">Things to do</label>
                    </li>
                  )}
                </ul>
              )}

              {this.state.cancelerrorMsg === true && (
                <div className="err-text">
                  Please Select Atleat One Itinerary
                </div>
              )}
            </div>
            <div className="cip-select-cntnr">
              <label>Reason for cancel / Modify</label>
              <Select
                placeholder="Select Reason"
                onChange={this.handleSelectChange.bind(this, "cancel_reason")}
                options={[
                  {
                    value: "I am not planning to go on the selected day/time.",
                    label: "I am not planning to go on the selected day/time.",
                  },
                  {
                    value: "I have made a wrong booking.",
                    label: "I have made a wrong booking.",
                  },
                  { value: "Medical reason", label: "Medical reason" },
                  {
                    value: "Others",
                    label: "Others (Please specify the reason below)",
                  },
                ]}
              />
              {this.state.error_cancel_reason !== "" && (
                <div className="err-text">{this.state.error_cancel_reason}</div>
              )}
            </div>
            <div className="cip-select-cntnr">
              <label>Others</label>
              <textarea
                placeholder="Please enter the reason here"
                name="cancel_other_reason"
                onChange={this.handleTextChange.bind(this)}
              ></textarea>
              {this.state.error_cancel_other_reason !== "" && (
                <div className="err-text">
                  {this.state.error_cancel_other_reason}
                </div>
              )}
            </div>
            <div className="cip-btn">
              <button
                className="cip-btn--danger"
                onClick={this.confirmCancel.bind(this)}
              >
                {this.state.loading && this.props.buttonLoader("danger")}
                Confirm and cancel
              </button>
            </div>
          </div>
        </ModalPopup>
      </>
    );
  }
}

export default Listpromo;
